import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { push } from "react-router-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import dasherize from "underscore.string/dasherize";
// Text Editor
import { convertToRaw, ContentState, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
//semantics
import { Row } from "antd";
//actions
import { actions } from "actions/resources";
import { searchCompanies, searchChallenges } from "actions/search";
//components
import NewChallengeForm from "./forms/new";
//utils
import { getUser } from "utils/auth";
//images
import defaultCompanyImage from "images/default_company.png";

import { LogoUploader } from "../../../components/generic/LogoUploader";
import { uploadPhoto } from "utils/image";

import { defaultChallangeImage } from "constants/defaultImages";

export class NewChallenge extends Component {
    state = {
        selectedChallenge: null,
        challenge_opportunity: EditorState.createEmpty(),
        companyResults: [],
        company_stakeholders: [],
        dateModalVisible: false,
        deliverables: EditorState.createEmpty(),
        deliverables_timeline: [],
        judging_criteria: EditorState.createEmpty(),
        key_considerations: EditorState.createEmpty(),
        work_environment: EditorState.createEmpty(),
        file: null,
        companyName: null,
        updates: EditorState.createEmpty()
    };

    constructor(props) {
        super(props);
        this.challengePictureRef = React.createRef();
    }

    componentWillMount() {
        const { match } = this.props;
        if (match.params.id) {
            this._fetchDependencies();
        } else {

            if (process.env.NODE_ENV === "development") {
                this._setupSampledata();
            }

        }
    }

    _setupSampledata = () => {

        const title = "Test " + Math.floor(Date.now() / 1000);

        const formattedObject = {
            logo: null,
            company_id: "936e30ab-e014-4e5d-a9f9-b635745cb537",
            company_stakeholders: [],
            company_engagement: [
                null
            ],
            functional_areas: [
                "Accounting"
            ],
            name: title,
            summary: null,
            deliverables_timeline: null,
            prize_type: "Monetary",
            requirements: null,
            skills: [
                "supply chain",
                "other"
            ],
            time_commitment: "1",
            teams: false,
            team_size: "2-3",
            number_of_teams: "1",
            travel_requirements: "None",
            status: "pending",
            typeform_form_id: "0",
            challenge_type: "case",
            is_tbd: false
        };

        this.setState({
            selectedChallenge: formattedObject,
            companyName: "Amazon"
        });

    }

    _fetchDependencies = async () => {
        const { fetchChallenge, fetchCompany } = this.props;
        let startDate, endDate;

        if (this.props.match.params.id) {
            const record = await fetchChallenge(this.props.match.params.id);
            const { payload } = record;
            if (payload.start_date) {
                startDate = payload.start_date.slice(0, 10);
            } else {
                startDate = null;
            }
            if (payload.end_date) {
                endDate = payload.end_date.slice(0, 10);
            } else {
                endDate = null;
            }

            const company = await fetchCompany(payload.company_id);

            if (company.payload) {
                this.setState({ companyName: company.payload.name });
            }

            this.setState({
                key_considerations: payload.blurb
                    ? EditorState.createWithContent(
                        ContentState.createFromBlockArray(
                            htmlToDraft(payload.blurb).contentBlocks,
                            htmlToDraft(payload.blurb).entityMap
                        )
                    )
                    : EditorState.createEmpty()
            });

            this.setState({
                challenge_opportunity: payload.objective
                    ? EditorState.createWithContent(
                        ContentState.createFromBlockArray(
                            htmlToDraft(payload.objective).contentBlocks,
                            htmlToDraft(payload.objective).entityMap
                        )
                    )
                    : EditorState.createEmpty()
            });

            this.setState({
                deliverables: payload.deliverables
                    ? EditorState.createWithContent(
                        ContentState.createFromBlockArray(
                            htmlToDraft(payload.deliverables).contentBlocks,
                            htmlToDraft(payload.deliverables).entityMap
                        )
                    )
                    : EditorState.createEmpty()
            });

            this.setState({
                judging_criteria: payload.judging_criteria
                    ? EditorState.createWithContent(
                        ContentState.createFromBlockArray(
                            htmlToDraft(payload.judging_criteria).contentBlocks,
                            htmlToDraft(payload.judging_criteria).entityMap
                        )
                    )
                    : EditorState.createEmpty()
            });

            this.setState({
                work_environment: payload.work_environment
                    ? EditorState.createWithContent(
                        ContentState.createFromBlockArray(
                            htmlToDraft(payload.work_environment).contentBlocks,
                            htmlToDraft(payload.work_environment).entityMap
                        )
                    )
                    : EditorState.createEmpty()
            });

            this.setState({
                updates: payload.updates
                    ? EditorState.createWithContent(
                        ContentState.createFromBlockArray(
                            htmlToDraft(payload.updates).contentBlocks,
                            htmlToDraft(payload.updates).entityMap
                        )
                    )
                    : EditorState.createEmpty()
            });

            const formattedObject = {
                logo: payload.logo,
                company_id: payload.company_id,
                company_stakeholders: payload.company_stakeholders,
                company_engagement: payload.company_engagement,
                functional_areas: payload.functional_areas,
                name: payload.name,
                summary: payload.summary,
                deliverables_timeline: payload.deliverables_timeline,
                prize_type: payload.prize_type,
                first_Prize: payload.prizes ? payload.prizes["1st"] : null,
                second_prize: payload.prizes ? payload.prizes["2nd"] : null,
                third_prize: payload.prizes ? payload.prizes["3rd"] : null,
                requirements: payload.requirements,
                skills: payload.skills,
                start_date: startDate,
                end_date: endDate,
                time_commitment: payload.time_commitment,
                teams: payload.teams,
                team_size: payload.team_size,
                number_of_teams: payload.number_of_teams,
                travel_requirements: payload.travel_requirements,
                status: payload.status,
                typeform_form_id: payload.typeform_form_id,
                challenge_type: payload.challenge_type,
                is_tbd: payload.is_tbd
            };

            this.setState({ selectedChallenge: formattedObject });
        }
    };

    _updatedCompanyStakeholder = (company_stakeholders, name) => {
        return company_stakeholders.map(async stakeholder => {
            // console.log("stakeholder", stakeholder);
            if (stakeholder && stakeholder.image && stakeholder.image.length > 0 && !Array.isArray(stakeholder.image) && stakeholder.image.startsWith("data:")) {

                let fileKey = `challenge-pictures/company-stakeholders/${dasherize(name)}-${moment().valueOf()}`;

                let imageData = {
                    fileKey: fileKey,
                    image: stakeholder.image
                };
                await uploadPhoto(imageData);
                stakeholder.image = `https://assets.wesolv.com/${fileKey}`;
            }

            return stakeholder;
        });
    };

    _processChallangeImage = async (data) => {
        return new Promise((resolve, reject) => {
            if (this.challengePictureRef.current && this.challengePictureRef.current.value.length > 0) {
                // console.log(this.challengePictureRef.current.value);
                let fileKey = `challenge-pictures/${dasherize(data.name)}${moment().valueOf()}`;
                let imageData = {
                    fileKey: fileKey,
                    image: this.challengePictureRef.current.value
                };
                uploadPhoto(imageData).then((value) => {
                    fileKey = `https://assets.wesolv.com/${fileKey}`;
                    resolve(fileKey);
                });

            } else {
                resolve(null);
            }
        });

    };

    _createOrUpdateChallenge = async data => {
        if (this.props.match.params.id) {
            this._updateChallenge(data)
        } else {
            this._createChallenge(data)
        }
    }

    _createChallenge = async data => {
        const { createChallenge } = this.props;
        const {
            challenge_opportunity,
            deliverables,
            judging_criteria,
            key_considerations,
            work_environment,
        } = this.state;

        // console.log("CREATE Challenge", data);

        let challengeLogo = await this._processChallangeImage(data);

        if (challengeLogo == null) {
            challengeLogo = defaultChallangeImage;
        }

        let updatedCompanyStakehodler = data.company_stakeholders ? await Promise.all(
            this._updatedCompanyStakeholder(data.company_stakeholders, data.name)
        )
            : null;

        // console.log("updatedCompanyStakehodler", updatedCompanyStakehodler);

        let formattedObject = {
            logo: challengeLogo,
            blurb: key_considerations.getCurrentContent().hasText()
                ? draftToHtml(convertToRaw(key_considerations.getCurrentContent()))
                : null,
            company_id: data.company_id,
            company_stakeholders: JSON.stringify(updatedCompanyStakehodler),
            company_engagement: JSON.stringify(data.company_engagement),
            deliverables: deliverables.getCurrentContent().hasText() ? draftToHtml(convertToRaw(deliverables.getCurrentContent()))
                : null,
            deliverables_timeline: JSON.stringify(data.deliverables_timeline),
            judging_criteria: judging_criteria.getCurrentContent().hasText()
                ? draftToHtml(convertToRaw(judging_criteria.getCurrentContent()))
                : null,
            objective: challenge_opportunity.getCurrentContent().hasText()
                ? draftToHtml(convertToRaw(challenge_opportunity.getCurrentContent()))
                : null,
            prize_type: data.prize_type,
            prizes: JSON.stringify({
                "1st": data.first_Prize,
                "2nd": data.second_prize,
                "3rd": data.third_prize
            }),
            name: data.name,
            requirements: JSON.stringify(data.requirements),
            skills: JSON.stringify(data.skills),
            summary: data.summary,
            start_date: data.start_date,
            end_date: data.end_date,
            time_commitment: data.time_commitment,
            teams: data.teams,
            team_size: data.team_size,
            number_of_teams: data.number_of_teams,
            travel_requirements: data.travel_requirements,
            typeform_form_id: data.typeform_form_id,
            status: data.status,
            work_environment: work_environment.getCurrentContent().hasText()
                ? draftToHtml(convertToRaw(work_environment.getCurrentContent()))
                : null,
            user_id: getUser().id,
            functional_areas: JSON.stringify(data.functional_areas),
            challenge_type: data.challenge_type,
            is_tbd: data.is_tbd
        };

        // console.log("_createChallenge", formattedObject);

        const response = await createChallenge(formattedObject);

        if (response) {
            this.setState({ selectedChallenge: null });
            searchChallenges();
            alert("Challenge saved.");
        }

    };

    _updateChallenge = async data => {

        const { updateChallenge } = this.props;
        const {
            challenge_opportunity,
            deliverables,
            judging_criteria,
            key_considerations,
            work_environment,
            updates
        } = this.state;

        let challengeLogo = await this._processChallangeImage(data);

        if (challengeLogo == null) {
            challengeLogo = data.logo || defaultCompanyImage;
        }

        let updatedCompanyStakehodler = data.company_stakeholders
            ? await Promise.all(
                this._updatedCompanyStakeholder(data.company_stakeholders, data.name)
            )
            : null;

        let formattedObject = {
            logo: challengeLogo,
            blurb: key_considerations.getCurrentContent().hasText()
                ? draftToHtml(convertToRaw(key_considerations.getCurrentContent()))
                : null,
            company_id: data.company_id,
            company_stakeholders: JSON.stringify(updatedCompanyStakehodler),
            company_engagement: JSON.stringify(data.company_engagement),
            deliverables: deliverables.getCurrentContent().hasText()
                ? draftToHtml(convertToRaw(deliverables.getCurrentContent()))
                : null,
            deliverables_timeline: JSON.stringify(data.deliverables_timeline),
            judging_criteria: judging_criteria.getCurrentContent().hasText()
                ? draftToHtml(convertToRaw(judging_criteria.getCurrentContent()))
                : null,
            objective: challenge_opportunity.getCurrentContent().hasText()
                ? draftToHtml(convertToRaw(challenge_opportunity.getCurrentContent()))
                : null,
            prize_type: data.prize_type,
            prizes: JSON.stringify({
                "1st": data.first_Prize,
                "2nd": data.second_prize,
                "3rd": data.third_prize
            }),
            name: data.name,
            requirements: JSON.stringify(data.requirements),
            skills: JSON.stringify(data.skills),
            summary: data.summary,
            start_date: data.start_date,
            end_date: data.end_date,
            time_commitment: data.time_commitment,
            teams: data.teams,
            team_size: data.team_size,
            number_of_teams: data.number_of_teams,
            travel_requirements: data.travel_requirements,
            typeform_form_id: data.typeform_form_id,
            status: data.status,
            work_environment: work_environment.getCurrentContent().hasText()
                ? draftToHtml(convertToRaw(work_environment.getCurrentContent()))
                : null,
            user_id: getUser().id,
            functional_areas: JSON.stringify(data.functional_areas),
            challenge_type: data.challenge_type,
            is_tbd: data.is_tbd,
            updates: updates.getCurrentContent().hasText()
                ? draftToHtml(convertToRaw(updates.getCurrentContent()))
                : null
        };

        // console.log("_updateChallenge", formattedObject);

        const response = await updateChallenge(
            this.props.match.params.id,
            formattedObject
        );

        if (response) {
            this.setState({ selectedChallenge: null });
            alert("Challenge updated.");
        }
    };

    _processEditorChange = (editorState, field) => {
        this.setState({
            [field]: editorState
        });
    };

    _searchCompanies = value => {
        const { searchCompanies } = this.props;
        searchCompanies(value);
    };


    render() {
        const { challenge, companyResults } = this.props;

        const {
            challenge_opportunity,
            company_stakeholders,
            dateModalVisible,
            deliverables,
            deliverables_timeline,
            judging_criteria,
            key_considerations,
            selectedChallenge,
            work_environment,
            companyName,
            updates
        } = this.state;

        let challengeImage = (challenge && challenge.logo) || defaultCompanyImage;

        // console.log("challengeImage", challengeImage);

        let initialValues = null;

        if (this.props.match.params.id) {
            initialValues = selectedChallenge
        } else {
            if (process.env.NODE_ENV === "development") {
                initialValues = selectedChallenge
            }
        }

        return (
            <div>
                <Row>
                    <div className="detail-spacer">
                        <Row>
                            <h1 style={{ fontSize: "40px", fontWeight: "bold" }}>
                                {this.props.match.params.id
                                    ? "Edit Challenge"
                                    : "New Challenge"}
                            </h1>
                        </Row>
                        <Row>
                            {this.props.match.params.id &&
                                challenge &&
                                challenge.challenge_intent ? (
                                <Link to={`/challenges/info/${this.props.match.params.id}`}>
                                    View Challenge Questionnaire
                                </Link>
                            ) : null}
                        </Row>
                    </div>
                </Row>

                <Row type="flex" className="logo-top">
                    <LogoUploader
                        currentImage={challengeImage}
                        ImageRef={this.challengePictureRef} />
                </Row>

                <NewChallengeForm
                    ref="NewChallengeForm"
                    companyName={companyName}
                    challengeOpportunity={challenge_opportunity}
                    companyStakeholders={company_stakeholders}
                    dateModalVisible={dateModalVisible}
                    deliverables={deliverables}
                    deliverablesTimeline={deliverables_timeline}
                    judgingCriteria={judging_criteria}
                    keyConsiderations={key_considerations}
                    updates={updates}
                    initialValues={initialValues}
                    onSubmit={this._createOrUpdateChallenge}
                    processEditorChange={this._processEditorChange}
                    workEnvironment={work_environment}
                    searchCompanies={this._searchCompanies}
                    results={(companyResults && companyResults.hits) || []}
                    toggleDateModal={() =>
                        this.setState({ dateModalVisible: !dateModalVisible })
                    }
                    isChallengeReadyForUpdate={this.props.match.params.id ? true : false}
                    id={this.props.match.params.id}
                />
            </div>
        );
    }
}

export default connect(
    state => ({
        challenge: state.resources.detail.challenge,
        challenges: state.resources.collection.challenge || [],
        companies: state.resources.collection.company,
        companyResults: state.search.companiesAlgolia || []
    }),
    dispatch => ({
        updateChallenge: bindActionCreators(actions.patchChallenge, dispatch),
        createChallenge: bindActionCreators(actions.createChallenge, dispatch),
        fetchChallenge: bindActionCreators(actions.fetchChallenge, dispatch),
        fetchChallenges: bindActionCreators(actions.fetchChallenges, dispatch),
        fetchCompany: bindActionCreators(actions.fetchCompany, dispatch),
        submitForm: bindActionCreators(submit, dispatch),
        redirect: bindActionCreators(push, dispatch),
        searchChallenges: bindActionCreators(searchChallenges, dispatch),
        searchCompanies: bindActionCreators(searchCompanies, dispatch)
    })
)(NewChallenge);



// WEBPACK FOOTER //
// ./src/components/dashboard/challenge/new.js